/**
 * Rótulo visível para um lado do veículo: nunca "esquerda/direita" — essas
 * palavras dependem de para onde quem fala está olhando, e a vítima pode
 * estar girada, tombada ou invertida dentro do carro. A referência do
 * veículo é sempre quem dirige: "lado do motorista" e "lado do passageiro".
 *
 * Convenção herdada de `perfilVeiculo.ts` (mesmo referencial do cenário
 * JSON): +X = lado esquerdo = motorista; -X = lado direito = passageiro.
 *
 * Regra do projeto: isto vale só para peças e cena do veículo. O corpo da
 * vítima continua em direita/esquerda anatômica (`RegiaoAnatomicaVitima`,
 * `ROTULOS_REGIAO`) — nunca reescrever anatomia como "lado do motorista".
 */
export type LadoVeiculo = 'esquerdo' | 'direito' | 'central'

export const ROTULOS_LADO_VEICULO: Readonly<Record<LadoVeiculo, string>> = {
  esquerdo: 'lado do motorista',
  direito: 'lado do passageiro',
  central: 'centro',
}

export function rotuloLadoVeiculo(lado: LadoVeiculo): string {
  return ROTULOS_LADO_VEICULO[lado]
}
